import apiClient from '@/utils/request'
import { IRequestPayload, IGeneralResponse } from '@/api/types'

export interface IUserInfo {
  id: string
  type: 'userinfo'
  attributes: IUserInfoAttributes
}

export interface IUserInfoAttributes {
  skype?: string
  telegram?: string
  viber?: string
  whatsapp?: string
  traffic_type: string[]
}

interface IUserInfoResponse extends IGeneralResponse {
  data: IUserInfo
}

export const saveInfo = async (
  params: IUserInfoAttributes
): Promise<IUserInfoResponse> => {
  const response = await apiClient.post<IUserInfoResponse>('/user_info', params)
  return response.data
}

export const getCurrentUserInfo = async (): Promise<IUserInfoResponse> => {
  const response = await apiClient.get<IUserInfoResponse>('/user_info')
  return response.data
}
